
import { Component, Prop, Vue } from 'vue-property-decorator'
import { ChatMessage } from '../../lib/chat/ChatMessage'

import BacModal from '../BacModal.vue'
import BacButton from '../BacButton.vue'
import { ChatService } from '@/lib/chat/ChatService'

@Component({
  components: {
    BacModal,
    BacButton
  }
})
export default class ChatMessageDeleteModal extends Vue {
  @Prop({ required: false }) chatService: ChatService | null = null
  @Prop({ required: true }) chatMessageId!: number

  async deleteMessage () {
    const res = await ChatMessage.delete(this.chatMessageId)
    if (this.chatService) {
      this.chatService.getLastMessages()
      this.$store.dispatch('loadAllMessages', this.$route.params.rallyRoundId + '?' + Math.round(Math.random() * 1e9)) // random to skip redis cache
    }
  }
}
